
import { Component, Prop, toNative, Vue, Watch } from 'vue-facing-decorator';
import { NotificationSegmentQuestion } from '@/entities/Notification/NotificationSegmentQuestion';
import ValidationSummary from '@/components/Common/ValidationSummary.vue';

import { NotificationItemParticipantInterest, NotificationSegmentQuestionWithChoices, NotificationParticipantGroup, NotificationFilterViewModel } from '@/entities/Notification/NotificationFilterViewModel';
import { FetchData, Root } from '@/main';
import { reactive } from 'vue';
import { minLength, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { NotificationFilter } from '@/entities/Notification/NotificationFilter';
import InputControlCheckBox from '@/components/Common/InputControlCheckBox.vue';
import { InputControlCheckBoxViewModel } from '@/entities/InputControlCheckBoxViewModel';
@Component({
  components: {
    InputControlCheckBox,
    ValidationSummary,
  },
})
class NotificationSelectAudienceFilter extends Vue {
  // Properties
  @Prop() private segmentQuestions?: NotificationSegmentQuestion[];
  @Prop() private filterProperties?: NotificationFilterViewModel;
  @Prop() private filterData?: NotificationFilter;

  private availableInterests: NotificationItemParticipantInterest[] = [];
  private availableSegments: NotificationSegmentQuestion[] = [];
  private availableSegmentsChoices: NotificationSegmentQuestionWithChoices[] = [];
  private availableParticipantGroups: NotificationParticipantGroup[] = [];
  private filteredSegmentsChoices: NotificationSegmentQuestionWithChoices[] = [];
  private filterparticipantCount: any = null;
  private newparticipantFilter: NotificationFilter = NotificationFilter.createEmpty();
  private participantCount = 0;
  private loadingImage: string = require('@/assets/Images/loading.png');
  private localNotificationLoading = false;
  private arrowUpIcon = require('@/assets/Images/blue-up-arrow.svg');
  private arrowDownIcon = require('@/assets/Images/blue-down-arrow.svg');
  private isArrowUp = false;
  private showMoreFilterOptions = false;
  private inputControlData: InputControlCheckBoxViewModel[] | undefined = undefined;

  // filter variables ids
  private seletedParticipantInterestId = 0;
  private seletedSegmentQuestionId = 0;
  private seletedSegmentChoiceId = 0;
  private seletedParticipantGroupId = 0;
  private selectedParticipantGroupIds: number[] = [];

  // validation summary
  private visibleValidationSummary = false;
  private validationErrorFields: string[] = [];
  private errors: string[] = [];
  private messages: string[] = [];
  private state = reactive({
    filterTitle: '',
  });

  private rules = {
    filterTitle: {
      required,
      minLength: minLength(1),
    },
  };
  private status(validation: { $error: any; $dirty: any }) {
    return {
      error: validation.$error,
      dirty: validation.$dirty,
    };
  }
  private v$ = useVuelidate(this.rules, this.state);
  private mounted() {
    if(!!this.filterData) {
      this.state.filterTitle = this.filterData.FilterName;
      this.seletedSegmentChoiceId = this.filterData.SegmentValueId;
      this.seletedSegmentQuestionId = this.filterData.SegmentId;
      this.seletedParticipantInterestId = this.filterData.InterestId;
      this.selectedParticipantGroupIds = this.filterData.GroupId;
      this.showMoreFilterOptions = this.isArrowUp = (!!this.seletedParticipantInterestId && this.seletedParticipantInterestId !== 0) || (!!this.seletedSegmentChoiceId && this.seletedSegmentChoiceId !== 0);
    }
    this.GetParticipantsInfoByFilter();
    // scroll the top of select filter
    Root.emit('new-notification-edit-item-pane', true);
    if (this.filterProperties !== undefined && this.filterProperties !== null) {
      this.availableInterests = this.filterProperties.ParticipantInterest!;
      this.availableSegments = this.segmentQuestions!;
      this.availableSegmentsChoices = this.filterProperties.SegmentQuestionWithChoices!;
      this.availableParticipantGroups = this.filterProperties.ParticipantGroup!;
      this.CorrectSelectedFilterData();
      this.SetDataForInputControl();
    }
    Root.on('notificationDetailLoading', (loadingval: boolean) => {
      this.localNotificationLoading = loadingval;
    });
  }
  private FilterSegmentChoices(event: any, bySelection: boolean) {
    this.seletedSegmentQuestionId = bySelection ? Number(event.target.value) : event;
    this.seletedSegmentChoiceId = this.seletedSegmentQuestionId === 0 ? 0 : this.seletedSegmentChoiceId;
    this.filteredSegmentsChoices = [];
    this.availableSegmentsChoices.forEach((value) => {
      if (value.QuestionId === this.seletedSegmentQuestionId) {
        this.filteredSegmentsChoices.push(value);
      }
    });
    if(bySelection) {
      this.GetParticipantsInfoByFilter();
    }
  }
  private ChangeSegmentChoices(event: any) {
    // handles drop down change of Segment choice drop down
    const segmentchoiceId = Number(event.target.value);
    this.seletedSegmentChoiceId = segmentchoiceId;
    // get participant count under these segment choice
    this.GetParticipantsInfoByFilter();
  }
  private ChangeParticipantInterest(event: any) {
    // handles drop down change of Participant Interests drop down
    const interestId = Number(event.target.value);
    this.seletedParticipantInterestId = interestId;
    // get participant count under these interests
    this.GetParticipantsInfoByFilter();
  }
  private GetParticipantsInfoByFilter() {
    const selectedFilterDetails = NotificationFilter.createEmpty();
    selectedFilterDetails.InterestId = this.seletedParticipantInterestId;
    selectedFilterDetails.SegmentId = this.seletedSegmentQuestionId;
    selectedFilterDetails.SegmentValueId = this.seletedSegmentChoiceId;
    selectedFilterDetails.GroupId = this.selectedParticipantGroupIds;
    // get Participant count for the selected Participant group / Segment choice / Interest
    FetchData('/Notification/GetParticipantsInfoByFilter', JSON.stringify({
      filterData: selectedFilterDetails,
    }))
      .then((response) => {
        const participantcount = response;
        this.filterparticipantCount = participantcount;
        this.participantCount = this.filterparticipantCount.userFilters;
      })
      .catch(() => {
        // Log err
      });
  }
  // Save filter with selected Interest/ Participant Group / Segment choice
  private async SaveFilter(val: any) {
    val.$touch();
    this.validationErrorFields = [];
    this.ClearErrorsList();
    this.ClearMessagesList();
    this.filtervalidations();
    const res = !await val.$validate();
    if(res) {
      if (val.filterTitle!.$error === true) {
        this.validationErrorFields.push(this.$t('Title').toString());
      }
      if (this.errors.length) {
        this.FillValidationErrors();
      }
      this.visibleValidationSummary = true;
      return;
    }
    val.$reset();
    if (this.errors.length) {
      this.FillValidationErrors();
      this.visibleValidationSummary = true;
      return;
    }
    const filterToSave = NotificationFilter.createEmpty();
    filterToSave.Id = this.filterData!.Id;
    filterToSave.FilterName = this.state.filterTitle;
    filterToSave.GroupId = this.selectedParticipantGroupIds;
    filterToSave.InterestId = this.seletedParticipantInterestId;
    filterToSave.SegmentId = this.seletedSegmentQuestionId;
    filterToSave.SegmentValueId = this.seletedSegmentChoiceId;
    FetchData('/Notification/SaveFilter', JSON.stringify({
      filterData: filterToSave,
    }))
      .then((response) => {
        this.newparticipantFilter.Id = response.data.mainFilterId;
        this.newparticipantFilter.FilterName = response.data.mainFilter;
        this.newparticipantFilter.GroupId = this.selectedParticipantGroupIds;
        this.newparticipantFilter.SegmentId = this.seletedSegmentQuestionId;
        this.newparticipantFilter.SegmentValueId = this.seletedSegmentChoiceId;
        this.newparticipantFilter.InterestId = this.seletedParticipantInterestId;
        // hide filter pane and show edit pane
        Root.emit('notification-show-filter-pane', false);
        Root.emit('set-newly-created-fiter-data', this.SetNewlyCreatedfilterData(response.data));
        // set newly created filter in edit pane
        this.$emit('setFilter', this.newparticipantFilter);
      })
      .catch(() => {
        // Log error if required
      });
  }

  // Use to set data for the filter created to send it to parent to be added in filter array
  private SetNewlyCreatedfilterData(data: any) {
    const newFilter = NotificationFilter.createEmpty();
    newFilter.Id = data.mainFilterId;
    newFilter.FilterName = data.mainFilter;
    newFilter.GroupId = this.selectedParticipantGroupIds;
    newFilter.InterestId = this.seletedParticipantInterestId;
    newFilter.SegmentId = this.seletedSegmentQuestionId;
    newFilter.SegmentValueId = this.seletedSegmentChoiceId;
    return newFilter;
  }
  private CloseCreateFilter() {
    Root.emit('notification-show-filter-pane', false);
  }
  // Clear Error List
  private ClearErrorsList() {
    this.errors = [];
  }
  // Clear Messages List
  private ClearMessagesList() {
    this.messages = [];
  }
  private FillValidationErrors() {
    const self = this;
    this.errors.forEach((item) => {
      self.validationErrorFields.push(item);
    });
  }
  private filtervalidations() {
    /* if no criterial is given for filter be created (i.e.) user ahs not selected
    any values from dropdown then validation error msg will be shown.*/
    if ( this.seletedParticipantInterestId === 0 &&
        (!this.selectedParticipantGroupIds || this.selectedParticipantGroupIds.length === 0) &&
        this.seletedSegmentChoiceId === 0
    ) {
      this.errors.push(this.$t('Dialogue.Filter.Validation').toString());
    }

  }
  private CloseValidationSummary(visible: boolean) {
    this.visibleValidationSummary = visible;
  }
  // Use to handle the toggle to show segment and interest
  private ShowMoreOptions() {
    this.showMoreFilterOptions = !this.showMoreFilterOptions;
    this.isArrowUp = !this.isArrowUp;
  }
  // Use to set label for the input control
  private GetParticipantCountInGroup(name: string, count: string) {
    return this.$t('Dialogue.Filter.ParticipantGroupCount',{name, count}).toString();
  }
  // To add or removbe group selected via input control
  private AddOrRemoveGroup(id: number) {
    const index = this.selectedParticipantGroupIds.indexOf(id);
    if (index === -1) {
      this.selectedParticipantGroupIds.push(id);
    } else {
      this.selectedParticipantGroupIds.splice(index, 1);
    }
  }
  private SetDataForInputControl() {
    this.inputControlData = [];
    this.availableParticipantGroups.forEach((item) => {
      const chkBoxData = InputControlCheckBoxViewModel.createEmpty();
      chkBoxData.Id = item.Id;
      chkBoxData.Label = this.GetParticipantCountInGroup(item.Name, item.TotalParticipantCount);
      chkBoxData.IsChecked = !!this.selectedParticipantGroupIds ? this.selectedParticipantGroupIds.includes(item.Id) : false;
      this.inputControlData!.push(chkBoxData);
    });
    // To set the data for segment choices in case of edit
    this.FilterSegmentChoices(this.seletedSegmentQuestionId, false);
  }
  // Use to add newwly added group from input control
  private SetSelectedParticipantGroupIds(val: InputControlCheckBoxViewModel[]) {
    this.selectedParticipantGroupIds = [];
    val.forEach((item) => {
      if (item.IsChecked) {
        this.selectedParticipantGroupIds.push(item.Id);
      }
    });
    this.GetParticipantsInfoByFilter();
  }
  private CorrectSelectedFilterData() {
    if(!!this.availableParticipantGroups && !!this.selectedParticipantGroupIds) {
      if(!this.availableParticipantGroups.some((obj) => this.selectedParticipantGroupIds.some((item) => item === obj.Id))) {
        this.selectedParticipantGroupIds = [];
      }
    }
    if(!!this.availableSegmentsChoices) {
      if(!this.availableSegmentsChoices.some((obj) => obj.ChoiceId === this.seletedSegmentChoiceId)) {
        this.seletedSegmentChoiceId = 0;
      }
    }
    if(!!this.availableInterests && !!this.seletedParticipantInterestId) {
      if(!this.availableInterests.some((obj) => obj.Id === this.seletedParticipantInterestId)) {
        this.seletedParticipantInterestId = 0;
      }
    }
  }
  @Watch('filterProperties')
  private checkifchanged(val: NotificationFilterViewModel) {
  // to update all drop downs
    if (val !== undefined && val !== null) {
      this.availableInterests = this.filterProperties!.ParticipantInterest!;
      this.availableSegments = this.segmentQuestions!;
      this.availableSegmentsChoices = this.filterProperties!.SegmentQuestionWithChoices!;
      this.availableParticipantGroups = this.filterProperties!.ParticipantGroup!;
      this.CorrectSelectedFilterData();
      this.SetDataForInputControl();
    }
  }
}
export default toNative(NotificationSelectAudienceFilter);
